import { useTranslation } from 'react-i18next';
import apiDefinitions from '../loyalty-performance-api-defintitions';
import APIDefinitions from 'components/api-definitions/api-definitions.component';

const OrderDefinitions = () => {
  const { t } = useTranslation();

  const orderDefinitions = [
    apiDefinitions.totalOrders,
    apiDefinitions.loyaltyEarnOrders,
    apiDefinitions.loyaltyBurnOrders,
    apiDefinitions.loyaltyNetZeroOrders,
    apiDefinitions.bonusEarnEvents,
    apiDefinitions.totalLoyaltyOrders,
    apiDefinitions.loyaltyContributionPercentOfOrders,
  ];

  return (
    <APIDefinitions
      definitions={orderDefinitions}
      type={t('page.loyaltyPerformanceReport.apiDefinitionTitles.orders.label')}
    />
  );
};

export default OrderDefinitions;
